import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { invokePostService, invokeGetService, toggleRightDrawer, handleSnackBar } from "../../../store/global/actions";
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress'
import RoutingRuleForm from "./RoutingRuleForm";
import SkeletonLoader from '../../atoms/loader/SkeletonLoader';
import { getReRender } from '../../../store/global/selectors';


export default function EditRoutingRule({ onClose, onCompletion, rrdefId, tag, element, hideCancel=false }) {
    const dispatch = useDispatch();
    const [rrdefs, setRrdefs] = useState([])
    const [selectedRrdef, setSelectedRrdef] = useState(null)
    const [selectedDelegate, setSelectedDelegate] = useState(null)
    const [allEvents, setAllEvents] = useState([]);
    const [clusterlets, setClusterlets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rrdefSchema, setRrdefSchema] = useState([]);
    const [defaultObj, setDefaultObj] = useState({});

    const reRender = useSelector(getReRender);
    

    useEffect(() => {
        setLoading(true);

        const promises = [dispatch(invokeGetService('rrdefsAndAssociates', [rrdefId]))];
          
        if (element?.protocol) {
            promises.push(dispatch(invokeGetService('getRrdefPlatformSchema', [element.protocol])));
        }
        Promise.all(promises)
            .then(([response, routingRuleSchema]) => {
                if (response.data !== undefined) {
                    setRrdefs(response.data.rrdefs);
                    setAllEvents(response.data.events);
                    setClusterlets(response.data.clusterlets)
                    setSelectedRrdef(response.data.selectedRrdef);
                    setSelectedDelegate(response.data.clusterlets.find(item => item._id === response.data?.selectedRrdef?.attributes?.delegate));
                    const dir = response.data.selectedRrdef?.attributes?.dir;
                    const ttype = response.data.selectedRrdef?.attributes?.ttype;
                    const tcmd = response.data.selectedRrdef?.attributes?.tcmd;
                    setDefaultObj({tag, dir, ttype, tcmd});
                } else if (response?.status === false && response?.code) {
                    dispatch(toggleRightDrawer());
                }
                if (routingRuleSchema.status) {
                    setRrdefSchema(routingRuleSchema.data);
                }
                setLoading(false);
            }).catch(() => setLoading(false));
    }, [rrdefId, reRender])




    const onUpdate = async (updatedRrdef) => {
        try {
            const response = await dispatch(invokePostService('updateRrdef', { rrdefData: updatedRrdef }, [rrdefId]));
            if (response.status === true) {
                onCompletion('Routing rule', 'edit');
            }
            return response;
        } catch (error) {
            console.log(error)
            dispatch(handleSnackBar({ open: true, message: 'Fetching rrdef data failed', severity: "error" }));
            return { status: false, message: 'Fetching rrdef data failed' };
        }
    }

    return (
        <>
            {loading && <Grid container direction={"row"} spacing={3}>
                <Grid item xs={12}>
                    <SkeletonLoader type="form" rows={9} />
                </Grid>
            </Grid>}
            {!loading && rrdefSchema.length > 0 &&
                <RoutingRuleForm
                    allEvents={allEvents}
                    rrdefs={rrdefs}
                    selectedDelegate={selectedDelegate}
                    clusterlets={clusterlets}
                    onSave={onUpdate}
                    onClose={onClose}
                    selectedRrdef={selectedRrdef}
                    rrdefSchema={rrdefSchema}
                    loading={loading}
                    defaultObj={defaultObj}
                    hideCancel={hideCancel}
                />}
        </>
    )
}